import { buildFormModule as buildSharedFormModule } from "@modyra/studio-codegen";
const CORE_PROFILE = { factoryImportSource: "@modyra/core", createCallName: "createForm" };
export function buildFormModule(project, stubNameFor) {
    return buildSharedFormModule(project, stubNameFor, CORE_PROFILE);
}
